import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { getFirestore } from "./firebase";

const useFirestoreUpdate = (collectionName, docId) => {
  const formatDate = (timestamp) => {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(timestamp);
  };

  const updateData = async (data) => {
    const db = getFirestore();
    const formattedDate = formatDate(Date.now());
    const newEntry = {
      ...data,
      createdAt: formattedDate,
    };

    await db
      .collection(collectionName)
      .doc(docId)
      .update({
        datos: firebase.firestore.FieldValue.arrayUnion(newEntry),
      });
  };

  return { updateData };
};

export default useFirestoreUpdate;
